import { HeaderType } from '../types/table-view.type'

export const getTableHeaders = (tableHeaders: string[]) => {
    const headerList: HeaderType[] = []
    tableHeaders.forEach((header: string) => {
        let item: HeaderType = {
            id: header,
            label: header.replaceAll('_', ' ').toUpperCase(),
            key: header,
            sortable:false
        }
        headerList.push(item)
    })
    return headerList
}

export const groupData = (sourceData: any, rowCount: number) => {
    if (sourceData.length != 0) {
        let groupedData: any = []
        for (let i = 0; i < sourceData.length; i = i + Number(rowCount)) {
            groupedData.push(sourceData.slice(i, i + Number(rowCount)))
        }
        return groupedData
    }
}

export const DeleteKeys = (dataObject: any, keysToDelete: string[]) => {
    dataObject.forEach((data: any) => {
        for (let index = 0; index < keysToDelete.length; index++) {
            delete data[keysToDelete[index]]
        }
    })
    return dataObject
}
